import styled from "styled-components";

// Antd Layout.Header default. Match it so the footer mirrors the page header.
const FOOTER_HEIGHT = 64;

export const RunPageWrapper = styled.div`
  /* Reserve enough space at the bottom of the scrollable content that the
     sticky footer never overlaps the last input panel — but only just enough.
     The footer's own border + shadow visually separates it from the content,
     so the buffer can be small. */
  padding-bottom: ${FOOTER_HEIGHT + 8}px;

  .run-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${FOOTER_HEIGHT}px;
    background-color: var(--bg-color-secondary, #ffffff);
    border-top: 1px solid var(--border-color, #e8e8e8);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
    z-index: 50;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 32px;
  }

  .run-footer-left {
    justify-self: start;
  }
  /* Shrink the secondary button down to roughly the primary button's size so
     Reset and Run Model read as a balanced pair. The default .secondary-btn
     style is 14px 24px padding with 161px min-width — which dwarfs the
     primary's 6px 24px when they sit side-by-side in a 64px footer. */
  .run-footer-left .secondary-btn {
    padding: 6px 24px;
    min-width: 0;
  }

  .run-footer-status {
    justify-self: center;
    font-size: 14px;
    color: var(--text-color-secondary, #595959);
    text-align: center;
    white-space: nowrap;
  }

  .run-footer-right {
    justify-self: end;
  }
`;
